<section class="fresh-bid-tenders pt-100" *ngIf="newTendersList" id="newlyadded_tenders">

  <div class="container d-flex justify-content-center">
    <div class="banner-overlap">
      <div class="d-flex justify-content-between align-items-center mb-26">
        <h2 class="section-heading">Newly Added Tenders</h2>
        <button class="view-all-outline-btn border-0 ms-3" title="All High Value Tenders List"
          (click)="navigateToAllTenders($event)">
          View All
        </button>
      </div>

      <div class="phone-width with-scroll-container d-none d-lg-block" *ngIf="isMobile">
        <div [id]="containerId" class="inner-container" (scroll)="onSliderScroll($event)"
          [ngClass]="{'top-performing-inner-container2': topPerformingContainer}">

          <div class="tender-card" *ngFor="let newtender of newTendersList; trackBy: trackByTenderId">
            <a (click)="navigate(newtender?.detailPageUrl); $event.preventDefault()"
              href="{{ baseUrl + newtender?.detailPageUrl }}">
              <h2 class="tender-title">{{ newtender?.authority }} Tender</h2>
            </a>

            <div *ngIf="newtender?.category?.length > 0" class="cursor-pointer tag-tooltip-hover">
              <div class="tender-status-badge blue-badge d-inline-block me-2">
                <span>{{ newtender.category [0] }}</span>
                <div *ngIf="newtender.category?.length > 1" class=" view-more-blue-text d-inline-block ">
                  <span class="tooltip-trigger">
                    +{{ newtender.category?.length - 1 }}
                  </span>
                  <div class="tooltip-content tag-dropdown">
                    <div class="tag-item" *ngFor="let item of newtender.category	?.slice(1)">
                      <span>{{ item }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="description-min-height">
              <p class="tender-description mb-0" [title]="newtender?.workDescription || newtender?.tenderTitle">
                <span [innerHTML]="(newtender?.workDescription || newtender?.tenderTitle) | wordSlice:15"></span>
                <span class="text-blue ms-2" style="cursor: pointer;">
                  <a (click)="navigate(newtender?.detailPageUrl); $event.preventDefault();"><b>..read more</b></a>
                </span>
              </p>

              <div class="tender-location">
                <ng-container *ngIf="newtender?.city">
                  <i class="sprite-img-list location-icon"></i>
                  <span class="location-text">{{newtender?.city}}<span *ngIf="newtender?.state">,
                    </span>{{newtender?.state}}</span>
                </ng-container>
              </div>
            </div>

            <div class="card-footer">
              <div class="tender-details">
                <div class="tender-info">
                  <span>Added on:</span>{{newtender?.addedOn | date : "dd MMM YYYY"}}
                </div>
                <div class="tender-info">
                  <span>Bid Before:</span> {{newtender?.bidBefore | date : "dd MMM YYYY"}}
                </div>
                <div class="tender-info">
                  <span>Tender Value:</span>
                  <span class="badge bg-danger p-0 text-start"
                    [ngClass]="{ 'text-red': newtender?.tenderAmount !== null && newtender?.tenderAmount !== 0}">
                    <strong> {{newtender?.tenderAmount === null || newtender?.tenderAmount === 0 ? 'Refer Document' :
                      newtender?.tenderAmount | tenderAmount}} </strong>
                  </span>
                </div>
              </div>
              <a (click)="navigate(newtender?.detailPageUrl)" class="view-details-button">View
                Details <i class="sprite-img-list arrow-right-white"></i> </a>
            </div>
          </div>

          <span class="left-arrow arrow" *ngIf="isLeftVisible" (click)="scrollSliderDiv(false)"
            [ngClass]="{'hide-arrow-div': hideContainer}">
            <i class="sprite-img icon-back"></i>
          </span>

          <span class="right-arrow arrow" *ngIf="isRightVisible" (click)="scrollSliderDiv(true)"
            [ngClass]="{'hide-arrow-div': hideContainer}">
            <i class="sprite-img icon-next cursor"></i>
          </span>

        </div>
      </div>
      <div class="d-block d-lg-none">
        <div class="mobile-card-overflow">
          <div class="mobile-card-row scroll-cards">

            <div class="tender-card" *ngFor="let newtender of newTendersList; trackBy: trackByTenderId">
              <a (click)="navigate(newtender?.detailPageUrl)"
                href="{{ baseUrl + newtender?.detailPageUrl }}">
                <h2 class="tender-title">{{ newtender?.authority }} Tender</h2>
              </a>

              <div *ngIf="newtender?.category?.length > 0" class="cursor-pointer tag-tooltip-hover">
                <div class="tender-status-badge blue-badge d-inline-block me-2">
                  <span>{{ newtender.category[0] }}</span>
                  <div *ngIf="newtender.category.length > 1" class="view-more-blue-text d-inline-block">
                    <span class="tooltip-trigger">
                      +{{ newtender.category.length - 1 }}
                    </span>
                    <div class="tooltip-content tag-dropdown">
                      <div class="tag-item" *ngFor="let item of newtender.category?.slice(1)">
                        <span>{{ item }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="description-min-height">
                <div
                  style="position: relative; max-width: 100%; line-height: 1.2em; max-height: 3.4em; overflow: hidden;">
                  <p class="tender-description mb-0" [title]="newtender?.workDescription || newtender?.tenderTitle">
                    <span [innerHTML]="(newtender?.workDescription || newtender?.tenderTitle) | wordSlice:11"></span>
                    <span style="white-space: nowrap;" class="text-blue ms-2" style="cursor: pointer;">
                      <a (click)="navigate(newtender?.detailPageUrl)"><b>...read more</b></a>
                    </span>
                  </p>
                </div>

                <div class="tender-location">
                  <ng-container *ngIf="newtender?.city">
                    <i class="sprite-img-list location-icon"></i>
                    <span class="location-text">{{newtender?.city}}<span *ngIf="newtender?.state">,
                      </span>{{newtender?.state}}</span>
                  </ng-container>
                </div>
              </div>

              <div class="card-footer">
                <div class="row m-0 w-100">
                  <div class="col-6 p-0">
                    <div class="tender-details">
                      <div class="tender-info">
                        <span>Added on:</span>{{newtender?.addedOn | date : "dd MMM YYYY"}}
                      </div>
                      <div class="tender-info">
                        <span>Bid Before:</span> {{newtender?.bidBefore | date : "dd MMM YYYY"}}
                      </div>
                    </div>
                  </div>
                  <div class="col-6 p-0">
                    <div class="tender-details">
                      <div class="tender-info">
                        <span>Tender Value:</span>
                        <span class="badge bg-danger p-0 text-start"
                          [ngClass]="{ 'text-red': newtender?.tenderAmount !== null && newtender?.tenderAmount !== 0}">
                          <strong> {{newtender?.tenderAmount === null || newtender?.tenderAmount === 0 ? 'Refer
                            Document':newtender?.tenderAmount | tenderAmount}} </strong>
                        </span>
                      </div>
                      <a (click)="navigate(newtender?.detailPageUrl)"
                        class="view-details-button m-0">View
                        Details <i class="sprite-img-list arrow-right-white"></i> </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>